import { Button } from 'foundations-components/transitional/components/Button';
import { Button as TrellisButton } from 'trellis-components/components/Button';
import { unsafeReactNode } from 'trellis-components/utils/unsafeReactNode';
import { CdpLink } from './CdpLink';
import { useUiVariant } from './UiVariantProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const TRELLIS_BUTTON_VARIANTS = {
  danger: 'primary-destructive',
  link: 'subtle-flush',
  primary: 'primary',
  secondary: 'normal',
  tertiary: 'normal',
  'tertiary-light': 'subtle',
  transparent: 'subtle'
};
export const TRELLIS_BUTTON_SIZES = {
  'extra-small': 'xs',
  xs: 'xs',
  small: 'sm',
  sm: 'sm',
  medium: 'md'
};
const TrellisCdpButton = ({
  'aria-label': ariaLabel,
  children,
  'data-test-id': dataTestId,
  disabled,
  external,
  href,
  onClick,
  padding,
  paddingInlineStart,
  size,
  target,
  type,
  use = 'secondary'
}) => {
  const isFlush = use === 'transparent' && (padding === '0' || paddingInlineStart === '0');
  if (href) {
    return /*#__PURE__*/_jsx(CdpLink, {
      "aria-label": ariaLabel,
      "data-test-id": dataTestId,
      href: href,
      external: external,
      target: target,
      disabled: disabled,
      onClick: onClick,
      children: children
    });
  }
  const buttonProps = {
    variant: isFlush ? 'subtle-flush' : TRELLIS_BUTTON_VARIANTS[use],
    size: size ? TRELLIS_BUTTON_SIZES[size] : undefined,
    disabled,
    type,
    onClick,
    dataTestId: dataTestId ? {
      root: dataTestId
    } : undefined
  };
  return ariaLabel ? /*#__PURE__*/_jsx(TrellisButton, Object.assign({}, buttonProps, {
    ariaLabel: {
      root: ariaLabel
    },
    icon: children
  })) : /*#__PURE__*/_jsx(TrellisButton, Object.assign({}, buttonProps, {
    children: unsafeReactNode(children)
  }));
};
export const CdpButton = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisCdpButton, Object.assign({}, props)) : /*#__PURE__*/_jsx(Button, Object.assign({}, props));
};